var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLink = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 5a.75.75 0 0 1-.75.75H5a2.25 2.25 0 0 0 0 4.5h1a.75.75 0 0 1 0 1.5H5a3.75 3.75 0 1 1 0-7.5h1a.75.75 0 0 1 .75.75zm2.5 6a.75.75 0 0 1 .75-.75h1a2.25 2.25 0 0 0 0-4.5h-1a.75.75 0 0 1 0-1.5h1a3.75 3.75 0 1 1 0 7.5h-1a.75.75 0 0 1-.75-.75z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 8.75a.75.75 0 0 0 0-1.5H6a.75.75 0 0 0 0 1.5h4z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export default ForwardRef;